import { SelectOption } from "@pulseops/common"

export namespace OPLReportForm {
  export interface OPLReportSearchedData {
    policyNumber: string
    clientName: string
    letterType: SelectOption | undefined
    fileName: string
    printingDate: Date | null
  }
} 